import { PlayCircle } from "lucide-react";

export const DemoBanner = () => (
  <div
    data-testid="demo-banner"
    className="banner-gradient fixed inset-x-0 top-0 z-40 flex h-9 items-center justify-center gap-3 border-b border-[rgba(79,142,247,0.28)] px-4"
  >
    <span className="text-[12px] text-[#cfe0fb]">
      <span className="hidden sm:inline">You are in <span className="font-semibold text-white">Demo Mode</span>. Take a tour:</span>
      <span className="font-semibold text-white sm:hidden">Demo Mode</span>
    </span>
    <button
      data-testid="demo-tour-button"
      onClick={() => window.dispatchEvent(new CustomEvent("aria:start-demo"))}
      className="flex h-6 items-center gap-1.5 rounded-full btn-gradient px-3 text-[11.5px] font-medium text-white transition-colors"
    >
      <PlayCircle size={12} /> Start tour
    </button>
  </div>
);
